import { useContext, useEffect } from "react";
import { Col, Row, Grid } from "../../../components/Grid";
import {
  ApplicationContextWrapper,
  ApplicationList,
} from "../../components/ApplicationList";
import { ApplicationParamsContext } from "../../components/ApplicationList/ApplicationContextWrapper";
import Application from "../Application/Application";
import { NoApplications } from "./SharedShortlist.styled";
import anonymousAvatar from "../../../assets/icons/anonymous-avatar.svg";
import { ApplicantAvatar } from "../Application/Application.styled";
import { DispatchPositionContext } from "../../context/PositionContext";
/**
 * A clickable list that show CV for the active application ( use ApplicationContextWrapper )
 * positionId - used for viewing in cockpit (internal)
 * positionUuid - used when viewing a shared list! (external)
 * useTracker - use a tracker ( only used for external viewing, and not internal preview )
 * @returns jsx
 */
const SharedShortlist = ({ positionId, positionUuid, useTracker, info }) => {
  return (
    <ApplicationContextWrapper
      uuid={positionUuid}
      positionId={positionId}
      shortlist={true}
      size={1000}
      useTracker={useTracker}
    >
      <Row mt={30} manageShareholderParent>
        <Col size={9} break="md" manageShareholderShortlist>
          <ApplicationList id={info?.position?.id} />
        </Col>
        <Col size={14} break="md" manageShareholderApplication>
          <ViewApplication id={info?.position?.id} />
        </Col>
      </Row>
    </ApplicationContextWrapper>
  );
};

const ViewApplication = () => {
  const {
    state: { list, index },
  } = useContext(ApplicationParamsContext);
  const positionDispatch = useContext(DispatchPositionContext);

  useEffect(() => {
    const selectedApp = list[index];
    if (selectedApp) {
      positionDispatch({
        type: "set_selected_application",
        payload: selectedApp,
      });
    }
  }, [list, index]);

  return (
    <>
      {list.length > 0 ? (
        <>
          <Application application={list} index={index} manageShareholder />
        </>
      ) : (
        <>
          <NoApplications>
            <Grid>
              <Row
                width="250px"
                flexDirectionMD="column"
                plMD="44"
                prMD="44"
                ptMD="26"
                bg="rgba(243, 243, 245, 0.6);"
                ml="0"
                mr="0"
                hideOnMobile
                application
              >
                <ApplicantAvatar large avatar={anonymousAvatar} />
              </Row>
            </Grid>
          </NoApplications>
        </>
      )}
    </>
  );
};

export default SharedShortlist;
